/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_With_Ssov21Inputs */

const en_auth_login_with_ssov21 = /** @type {(inputs: Auth_Login_With_Ssov21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in`)
};

/**
* | output |
* | --- |
* | "Sign in" |
*
* @param {Auth_Login_With_Ssov21Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const auth_login_with_ssov21 = /** @type {((inputs?: Auth_Login_With_Ssov21Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_With_Ssov21Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth_login_with_ssov21(inputs)
});
export { auth_login_with_ssov21 as "auth_login_with_ssoV2" }